
import { AppInsights } from '@/appInsights';
import { CMPApi } from '@/modules/cmp-api';
import { PersonalDetail, EmploymentDetail, CommitteeContactDetail, MemberAddress, CommitteeView, Country } from '@/modules/typescript-cmpApi-client/models';
import store from '@/store'
import { EventEmitter } from 'events';
import { Options, Vue } from 'vue-class-component';
import { Inject, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

@Options({
  props: {
    editType: Number,
    pDetails: {},
    cDetails: {},
    eDetails: {},
    myCommittees: {},
  },
  emits: ['update:eDetails', 'update:cDetails', 'close'],
  components: {}
})
export default class DetailsEdit extends Vue {
  editType!: number;
  pDetails!: PersonalDetail;
  eDetails!: EmploymentDetail;
  cDetails!: CommitteeContactDetail;
  myCommittees!: CommitteeView[];

  private eDetailsTemp!: EmploymentDetail;
  private cDetailsTemp!: CommitteeContactDetail;

  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;
  private formDirty = false;
  private canSubmit = false;

  private isPcHolder = this.cDetails.isPcHolder;
  private firmName = '';
  private phone = '';
  private phoneAreaCode = '';
  private email = '';

  private countryList = [];
  private buildingTypeList = [];
  private streetTypeList = [];
  private suburbList: MemberAddress[] = [];
  private postcodeList = [];
  private deliveryTypeList = [];
  private dxExchangeTypeList = [];

  private country: any = '';
  private buildingType: any = '';
  private streetType: any = '';
  private deliveryType: any = '';
  private dxExchangeType: any = '';

  private address: MemberAddress = {};
  private addressEncoded = '';

  private isOversea = false;

  // private search = '';
  private isSearching = false;
  private isOpen = false;
  private isPostcodeSearching = false;
  private isPostcodeOpen = false;
  private isSuburbValid = true;

  private arrowCounter = -1;
  private searchDebounced: any = null;

  get displayName() {
    return this.pDetails.displayName;
  }

  get defaultCountry() {
    let _c: Country[] = [];
    if (this.countryList && this.countryList.length > 0) {
      _c = this.countryList.filter((c: Country) => {
        return c.name.toLowerCase() === 'australia';
      });
    }
    this.address.countryId = _c[0].id;
    this.address.countryName = _c[0].name;
    return {id: _c[0].id, name: _c[0].name }
  }

  private query = '';

  @Watch('query')
  private onKeywordChange(): void {
    setTimeout(this.searchDebounced.cancel, 0);
    setTimeout(this.searchDebounced, 0);
  }

  created() {
    this.getCountryList();
    this.getBuildingTypeList();
    this.getStreetTypeList();
    this.getDeliveryTypeList();
    this.getDxExchangeTypeList();
  }

  mounted() {
    this.init();
    document.body.classList.add('modal-open');
    document.addEventListener('click', this.handleClickOutside);

    this.searchDebounced = debounce(() => {
      this.getSuburbPostcodeList();
    }, 500);
  }

  unmounted() {
    document.addEventListener('click', this.handleClickOutside);
    document.body.classList.remove('modal-open');
  }

  private handleClickOutside(event: any) {
    // console.log('handleClickOutside: ', event);
    if (this.$el !== (event.target)) {
      this.isOpen = false;
      this.arrowCounter = -1;
    }
  }

  private init() {
    this.formDirty = false;

    // clone objects for editing
    this.eDetailsTemp = { ... this.eDetails };
    this.cDetailsTemp = { ... this.cDetails };

    this.firmName = this.eDetailsTemp.firmName ? this.eDetailsTemp.firmName : '';
    if (this.cDetailsTemp.phone && this.cDetailsTemp.phone.phoneAreaCode) {
      this.phoneAreaCode = this.cDetailsTemp.phone.phoneAreaCode;
    }

    if (this.cDetailsTemp.phone && this.cDetailsTemp.phone.phoneNumber) {
      this.phone = this.cDetailsTemp.phone.phoneNumber;
    }

    this.email = this.cDetailsTemp.email ? this.cDetailsTemp.email : '';
    // if (this.editType == 3) {
    this.address = { ... this.cDetailsTemp.address };
    this.address = this.addressInit(this.address);

    if (this.address.countryId !== 0) {
      this.country = { id: this.address.countryId, name: this.address.countryName };
      this.isOversea = this.country.name ? this.country.name.toLowerCase() !== 'australia' : false;
    } else {
      this.country = this.defaultCountry;
    }

    if (this.address.buildingTypeId !== 0) {
      this.buildingType = { id: this.address.buildingTypeId, name: this.address.buildingTypeName };
    }

    if (this.address.streetTypeId !== 0) {
      this.streetType = { id: this.address.streetTypeId, name: this.address.streetTypeName };
    }

    if (this.address.deliveryTypeId !== 0) {
      this.deliveryType = { id: this.address.deliveryTypeId, name: this.address.deliveryTypeName };
    }

    if (this.address.dxExchangeTypeId !== 0) {
      this.dxExchangeType = { id: this.address.dxExchangeTypeId, name: this.address.dxExchangeTypeName };
    }

    this.updatePreview();
    // }
  }

  private addressInit(a: MemberAddress): MemberAddress {
    // set default value of address
    a = a || [];
    a.addressTypeId = a.addressTypeId || 1;
    a.buildingName = a.buildingName || '';
    a.buildingNumber = a.buildingNumber || null;
    a.buildingTypeId = a.buildingTypeId || 0;
    a.buildingTypeName = a.buildingTypeName || null
    a.countryId = a.countryId || 0;
    a.countryName = a.countryName || null;
    a.deliveryTypeId = a.deliveryTypeId || 0;
    a.deliveryTypeName = a.deliveryTypeName || null;
    a.dxExchangeTypeId = a.dxExchangeTypeId || 0;
    a.dxExchangeTypeName = a.dxExchangeTypeName || null;
    a.dxNumber = a.dxNumber || null;
    a.foreignAddress = a.foreignAddress || null;
    a.id = a.id || 0;
    a.level = a.level || null;
    a.memberId = a.memberId || 0;
    a.poBox = a.poBox || null;
    a.postcode = a.postcode || null;
    a.stateId = a.stateId || 0;
    a.stateName = a.stateName || null;
    a.streetName = a.streetName || null;
    a.streetNumber = a.streetNumber || null;
    a.streetTypeId = a.streetTypeId || 0;
    a.streetTypeName = a.streetTypeName || '';
    a.suburbId = a.suburbId || 0;
    a.suburbName = a.suburbName || null;

    return JSON.parse(JSON.stringify(a).replace(/:null/gi, ':""'));
  }

  private resetForm() {
    this.$emit('close');
  }

  private setForeignAddress(cName: any) {
    this.address.countryId = cName.id;
    this.address.countryName = cName.name;
    if (cName.name.toLowerCase() == 'australia') {
      this.isOversea = false;
    } else {
      this.isOversea = true;
    }
    // console.log('this.isOversea: ', this.isOversea, cName);
    this.addressEncoded = this.getAddressEncoded;
    this.mandatoryCheck();
  }

  private setBuildingType(bt: any) {
    this.address.buildingTypeId = bt.id || '';
    this.address.buildingTypeName = bt.name || '';
    this.addressEncoded = this.getAddressEncoded;
    this.mandatoryCheck();
  }

  private setStreetType(st: any) {
    this.address.streetTypeId = st.id || '';
    this.address.streetTypeName = st.name || '';
    this.addressEncoded = this.getAddressEncoded;
    this.mandatoryCheck();
  }

  private setDeliveryType(dt: any) {
    this.address.deliveryTypeId = dt.id || '';
    this.address.deliveryTypeName = dt.name || '';
    this.addressEncoded = this.getAddressEncoded;
    this.mandatoryCheck();
  }

  private setDxExchangeType(dx: any) {
    // console.log('DX exchange: ', dx);
    this.address.dxExchangeTypeId = dx.id || '';
    this.address.dxExchangeTypeName = dx.name || '';
    this.addressEncoded = this.getAddressEncoded;
    this.mandatoryCheck();
  }

  private setAddressType() {
    // console.log('addressType: ', this.address.addressTypeId);
    this.mandatoryCheck();
  }


  get getAddressEncoded() {
    const address: MemberAddress = JSON.parse(JSON.stringify(this.address).replace(/:null/gi, ':""'));
    let addressEncoded = '';

    if (this.country && this.country['name']?.toLowerCase() == 'australia') {
      switch (address['addressTypeId']) {
        case 1: // Street
          addressEncoded = address['buildingName'] + '\n';
          addressEncoded += address['buildingTypeName'] + ' ' + address['buildingNumber'] + ' ' + address['level'] + '\n';
          addressEncoded += address['streetNumber'] + ' ' + address['streetName'] + ' ' + address['streetTypeName'] + '\n';
          addressEncoded += address['suburbName'] + ', ' + address['stateName'] + ' ' + address['postcode'];
          break;
        case 2: // PO Box
          addressEncoded = address['deliveryTypeName'] + ' ' + address['poBox'] + '\n';
          addressEncoded += address['suburbName'] + ', ' + address['stateName'] + ' ' + address['postcode'];
          break;
        case 3: // DX address
          addressEncoded = 'DX ' + address['dxNumber'] + '\n';
          addressEncoded += address.dxExchangeTypeName + '\n';
          break;
      }
    } else {
      addressEncoded = this.address.foreignAddress || ' ';
    }
    // console.log('addressEncoded preview: ', addressEncoded.trim());
    return addressEncoded.trim();
  }

  private updatePreview() {
    this.mandatoryCheck();
    this.addressEncoded = this.getAddressEncoded;
  }

  private getCountryList() {
    const countryList = store.getters.getCountryList;
    this.countryList = countryList == null ? null : JSON.parse(countryList);

    if (this.countryList == null) {
      this.apiService.CodeApi?.apiV1CodeGetCountriesGet()
        .then((res: any) => {
          this.countryList = res.data.data;
          store.dispatch('setCountryList', this.countryList);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting country list: ' + err.response.status);
          this.ai.trackException('Error getting country list: ' + err);
        })
    }
  }

  private getBuildingTypeList() {
    this.apiService.CodeApi?.apiV1CodeGetBuildingTypesGet()
      .then((res: any) => {
        this.buildingTypeList = res.data.data;
      })
      .catch((err: any) => {
        console.log(err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error getting building type list: ' + err.response.status);
        this.ai.trackException('Error getting building type list: ' + err);
      })
  }

  private getStreetTypeList() {
    this.apiService.CodeApi?.apiV1CodeGetStreetTypesGet()
      .then((res: any) => {
        this.streetTypeList = res.data.data;
      })
      .catch((err: any) => {
        console.log(err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error getting street type list: ' + err.response.status);
        this.ai.trackException('Error getting street type list: ' + err);
      })
  }

  private getSuburbPostcodeList() {
    // console.log('form is dirty: ', this.formDirty);
    if (this.formDirty) {
      if (this.query.length == 4 && parseInt(this.query) > 999) {
        this.getPostcodeList();
      } else {
        this.getSuburbList();
      }
    }
  }

  private getSuburbList() {
    if (this.query.length > 2) {
      this.isSearching = true;
      const body: {} = { 'keyword': this.query.trim() }
      this.apiService.CodeApi?.apiV1CodeGetSuburbStatePostcodeBySuburbPost(body)
        .then((res: any) => {
          this.processResult(res);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting suburb list: ' + err.response.status);
          this.ai.trackException('Error getting suburb list: ' + err);
          this.isSearching = false;
        })
    }

  }

  private getPostcodeList() {
    if (this.query.length == 4) {
      this.isSearching = true;
      const body: {} = { 'keyword': this.query.trim() }
      this.apiService.CodeApi?.apiV1CodeGetSuburbStatePostcodeByPostcodePost(body)
        .then((res: any) => {
          this.processResult(res);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Postcode List: ' + err.response.status);
          this.ai.trackException('Error getting Postcode list: ' + err);
          this.isSearching = false;
        })
    }
  }

  private processResult(res: any) {
    // const el = this.$refs.suburbName as HTMLElement;
    this.suburbList = [];
    this.suburbList = res.data.data;
    this.isSearching = false;
    // console.log('suburbList.length: ', this.suburbList.length);
    if (this.suburbList.length > 0) {
      this.arrowCounter = -1;
      this.isOpen = this.suburbList.length > 0;
      // el.className = 'has-success';
      // console.log('suburbList: ', this.suburbList);
    } else {
      // console.log('Not result return', this.suburbList.length);
      this.isOpen = false;
      // el.className = 'has-error';
      this.canSubmit = false;
    }
  }

  private getDeliveryTypeList() {
    this.apiService.CodeApi?.apiV1CodeGetDeliveryTypesGet()
      .then((res: any) => {
        this.deliveryTypeList = res.data.data;
      })
      .catch((err: any) => {
        console.log(err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error getting street type list: ' + err.response.status);
        this.ai.trackException('Error getting street type list: ' + err);
      })
  }

  private getDxExchangeTypeList() {
    const dxExchangeTypeList = store.getters.getDxExchangeTypeList;
    this.dxExchangeTypeList = dxExchangeTypeList == null ? null : JSON.parse(dxExchangeTypeList);
    if (this.dxExchangeTypeList == null) {
      this.apiService.CodeApi?.apiV1CodeGetDxExchangeListGet()
        .then((res: any) => {
          this.dxExchangeTypeList = res.data.data;
          store.dispatch('setDxExchangeTypeList', this.dxExchangeTypeList);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error DX Exchange List: ' + err.response.status);
          this.ai.trackException('Error getting DX Exchange list: ' + err);
        })
    }
  }

  private saveMyMemberDetail() {
    this.eDetailsTemp.firmName = this.firmName;
    this.addressCleanUp(); // remove unrelated address info
    console.log('address: ', this.address)
    this.cDetailsTemp.address = { ... this.address };
    this.cDetailsTemp.phone = { phoneAreaCode: this.phoneAreaCode.toString(), phoneNumber: this.phone.toString() };
    this.cDetailsTemp.email = this.email;
    let _payload = {};
    if (this.isPcHolder) {
      _payload = { committeeContactDetail: this.cDetailsTemp };
    } else {
      _payload = { employmentDetail: this.eDetailsTemp, committeeContactDetail: this.cDetailsTemp };
    }

    this.apiService.memberApi?.apiV1MemberSaveMyMemberDetailPost(_payload)
      .then((res: any) => {
        // update parent object
        this.eDetails.firmName = this.eDetailsTemp.firmName;

        this.cDetails.address = { ... this.address };
        this.cDetails.phone = this.cDetailsTemp.phone;
        this.cDetails.email = this.cDetailsTemp.email;
        this.eventCtrl.emit('show-snackbar', 'success', 'Change saved.');
        this.ai.trackEvent('saveCommitteeContactDetail: ' + JSON.stringify(res));
        this.$emit('close');
      })
      .catch((err: any) => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error saving address data: ' + err.response.status);
        this.ai.trackException('Error saving details: ' + err);
      })
  }

  private addressCleanUp() {
    const _t: MemberAddress = {};
    _t.countryId = this.address.countryId;
    _t.countryName = this.address.countryName;
    if (this.country && this.country['name']?.toLowerCase() == 'australia') {
      _t.addressTypeId = this.address.addressTypeId;
      switch (this.address.addressTypeId) {
        case 1: // Street
          _t.buildingName = this.address.buildingName;
          _t.buildingTypeId = this.address.buildingTypeId;
          _t.buildingTypeName = this.address.buildingTypeName;
          _t.buildingNumber = this.address.buildingNumber;
          _t.level = this.address.level;
          _t.streetNumber = this.address.streetNumber;
          _t.streetName = this.address.streetName;
          _t.streetTypeName = this.address.streetTypeName;
          _t.streetTypeId = this.address.streetTypeId;

          _t.stateId = this.address.stateId;
          _t.stateName = this.address.stateName;
          _t.suburbId = this.address.suburbId;
          _t.suburbName = this.address.suburbName;
          _t.postcode = this.address.postcode;
          break;
        case 2: // PO Box
          _t.deliveryTypeId = this.address.deliveryTypeId;
          _t.deliveryTypeName = this.address.deliveryTypeName;
          _t.poBox = this.address.poBox;
          _t.stateId = this.address.stateId;
          _t.stateName = this.address.stateName;
          _t.suburbId = this.address.suburbId;
          _t.suburbName = this.address.suburbName;
          _t.postcode = this.address.postcode;
          break;
        case 3: // DX address
          _t.dxNumber = this.address.dxNumber;
          _t.dxExchangeTypeId = this.address.dxExchangeTypeId;
          _t.dxExchangeTypeName = this.address.dxExchangeTypeName;
          break;
      }
    } else {
      _t.addressTypeId = 1;
      _t.foreignAddress = this.address.foreignAddress;
    }
    this.address = {};
    this.address = {... _t};
  }


  private isFirmNameValid() {
    const el = this.$refs.firmRef as HTMLElement;
    el.className = (this.firmName.trim() === '') ? 'has-error' : 'has-success';
    return (this.firmName.trim() === '') ? false : true;
  }

  private isPhoneNumberValid() {
    const el = this.$refs.phoneRef as HTMLElement;
    el.className = (this.phone.trim() === '') ? 'has-error' : 'has-success';
    return (this.phone.trim() === '') ? false : true;
  }

  get validEmail() {
    const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
    return (this.email !== '') && (reg.test(this.email));
  }

  private isEmailAddressValid() {
    const el = this.$refs.emailRef as HTMLElement;
    // tslint:disable-next-line:max-line-length
    const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
    el.className = (this.email === '') ? 'has-error' : (reg.test(this.email)) ? 'has-success' : 'has-error';
    return reg.test(this.email) ? true : false;
  }

  private isStreetNumberValid() {
    const el = this.$refs.streetNumber as HTMLElement;
    el.className = (this.address.streetNumber.trim() === '') ? 'has-error' : 'has-success';
    return (this.address.streetNumber.trim() === '') ? false : true;
  }

  private isStreetNameValid() {
    const el = this.$refs.streetName as HTMLElement;
    el.className = (this.address.streetName.trim() === '') ? 'has-error' : 'has-success';
    return (this.address.streetName.trim() === '') ? false : true;
  }

  private isPoBoxValid() {
    const el = this.$refs.poBox as HTMLElement;
    el.className = (this.address.poBox.trim() === '') ? 'has-error' : 'has-success';
    return (this.address.poBox.trim() === '') ? false : true;
  }

  private isDxNumberValid() {
    const el = this.$refs.dxNumber as HTMLElement;
    el.className = (this.address.dxNumber.trim() === '') ? 'has-error' : 'has-success';
    return (this.address.dxNumber.trim() === '') ? false : true;
  }

  private isDxExchangeValid() {
    const el = this.$refs.dxExchangeDesc as HTMLElement;
    el.className = (this.address.dxNumber.trim() === '') ? 'has-error' : 'has-success';
    return (this.address.dxNumber.trim() === '') ? false : true;
  }

  private isSuburbNameValid() {
    this.formDirty = true;
    const el = this.$refs.suburbName as HTMLElement;
    const isEmpty = this.address.suburbName.trim() === '';
    el.className = (isEmpty) ? 'has-error' : 'has-success';
    this.isSuburbValid = el.className == 'has-success' ? true : false;
    return isEmpty;
  }

  private mandatoryCheck() {
    const firm = this.firmName.trim().length > 0;
    //const phone = this.phone.length > 0;
    const email = this.isEmailAddressValid();
    let _canSubmit = false;
    // console.log(this.isOversea, this.address.foreignAddress.length, this.country.name);
    if (this.isOversea) {
      _canSubmit = this.address.foreignAddress !== '' && email; //phone && 
    } else {
      const suburbName = this.address.suburbName && this.address.suburbName.trim().length > 0;
      const postcode = this.address.postcode && this.address.postcode.trim().length == 4;
      const streetNumber = this.address.streetNumber && this.address.streetNumber.trim().length > 0;
      const streetName = this.address.streetName && this.address.streetName.trim().length > 0;
      const streetTypeName = this.address.streetTypeName && this.address.streetTypeName.trim().length > 0;
      const deliveryTypeName = this.address.deliveryTypeName && this.address.deliveryTypeName.trim().length > 0;
      const poBox = this.address.poBox && this.address.poBox.trim().length > 0;
      // const dxNumber = this.address.dxNumber && this.address.dxNumber.trim().length > 0;
      // const dxExchangeTypeName = this.address.dxExchangeTypeName && this.address.dxExchangeTypeName.trim().length > 0;
      switch (this.address.addressTypeId) {
        case 1:
          _canSubmit = streetNumber && streetName && streetTypeName && suburbName && postcode && email; //phone && 
          break;
        case 2:
          _canSubmit = deliveryTypeName && poBox && suburbName && postcode && email; //phone && 
          break;
        // case 3:
        //   _canSubmit = dxNumber && dxExchangeTypeName && phone && email;
        //   break;
      }

    }

    if (this.isPcHolder) {
      this.canSubmit = _canSubmit;
    } else {
      this.canSubmit = firm && _canSubmit;
    }
  }

  private highlightWord(word: string) {
    try {
      const regex = new RegExp('(' + this.query + ')', 'ig');
      // console.log(word.replace(regex, '<mark>$1</mark>'));
      return word.replace(regex, '<mark>$1</mark>');
    } catch (err) {
      return word;
    }
  }

  private onArrowDown() {
    if (this.suburbList.length > 0) {
      if (this.arrowCounter < this.suburbList.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    } else {
      if (this.arrowCounter < this.postcodeList.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    }
  }

  private onArrowUp() {
    if (this.arrowCounter > 0) {
      this.arrowCounter = this.arrowCounter - 1;
    }
  }

  private onEnter() {
    this.formDirty = false;
    this.isOpen = false;
    if (this.suburbList.length > 0) {
      // this.isSuburbNameValid();
      this.selectSuburbFromSearch(
        this.suburbList[this.arrowCounter === -1 ? 0 : this.arrowCounter]
      );
    }
  }

  private selectSuburbFromSearch(suburb: any) {
    // console.log('onenter: ', suburb);
    this.isOpen = false;
    this.address.suburbId = suburb.suburbId;
    this.address.suburbName = suburb.suburbName;
    this.address.postcode = suburb.postcode;
    this.address.stateName = suburb.stateName;
    this.query = '';
    this.mandatoryCheck();
  }

}



